import { Controller } from "@hotwired/stimulus"

// Fades sections in as they come into view. Anything already on screen shows at once,
// and readers who asked for less motion get everything visible from the start.
export default class extends Controller {
    connect() {
        const targets = this.element.querySelectorAll(".reveal")

        if (!("IntersectionObserver" in window) || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            targets.forEach((el) => el.classList.add("is-in"))
            return
        }

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return
                entry.target.classList.add("is-in")
                this.observer.unobserve(entry.target)
            })
        }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 })

        targets.forEach((el) => this.observer.observe(el))
    }

    disconnect() {
        this.observer?.disconnect()
    }
}
